'use client';

import useUI from '@app/components/ui/state';
import { Button } from 'mmds';
import s from './product-assistance.module.css';

const ProductAssistanceOptions = ({ labels }) => {
    const { setProductAssistanceView, toggleUI } = useUI();

    const handleLabelClick = (id: string): void => {
        setProductAssistanceView(id);
        toggleUI('product-assistance');
    };
    return (
        <nav>
            <ul role="list" className={s.cluster}>
                {Object.values(labels).map(
                    ({ id, label, hasData, icon }: any) =>
                        hasData && (
                            <li key={id}>
                                <Button
                                    variant="text"
                                    label={label}
                                    icon={icon || ""}
                                    onClick={() => handleLabelClick(id)}
                                />
                            </li>
                        )
                )}
            </ul>
        </nav>
    );
};

export default ProductAssistanceOptions;
